import { glsl_functions } from "./glsl";
export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
const lineNumberRegexp = /(\d+):\d+\)?/;
export function printError(error, fnStr, tag) {
    const stack = typeof error === "string" ? error.split("\n") : error.stack?.split("\n");
    const title = stack[0];
    const line = stack[1];
    const lineNumber = line.match(lineNumberRegexp)
        ? parseInt(line.match(lineNumberRegexp)[0].split(":")[1])
        : title.match(lineNumberRegexp)
            ? parseInt(title.match(lineNumberRegexp)[0].split(":")[1])
            : null;
    console.info(`\x1b[1m[${tag}] ${title}${lineNumber ? ` at ${lineNumber}` : ""}:\x1b[0m\n\n` + strToLines(fnStr, lineNumber, 1000));
}
export function strToLines(str = "", eLine, gap) {
    return str
        .split("\n")
        .map((line, index) => {
        const lineIndex = "0".repeat(3 - (index + 1).toString().length) + (index + 1).toString();
        if (eLine && index === eLine - 1) {
            return `\x1b[31m${lineIndex}: ${line}\x1b[0m`;
        }
        return `${lineIndex}: ${line}`;
    })
        .filter((line, index) => {
        if (!eLine)
            return true;
        gap = gap || 5;
        return index > eLine - gap && index < eLine + gap;
    })
        .join("\n");
}
export function minifyCode(source) {
    return source.trim().replaceAll("\t", "").replaceAll("  ", "").replaceAll("\n", "");
}
export function glslFn(name) {
    const fn = glsl_functions.find(f => f.name === name);
    if (!fn)
        throw new Error(`Function ${name} not found`);
    return fn;
}
export function trimSource(source) {
    return source
        .trim()
        .split("\n")
        .map(s => s.replace(/\t/g, " ").replace(/ {2,}/g, " ").trim())
        .join("\n\t");
}
export function mod(a, b) {
    return ((a % b) + b) % b;
}
export function map(value, inputMin, inputMax, outputMin, outputMax) {
    return ((value - inputMin) * (outputMax - outputMin)) / (inputMax - inputMin) + outputMin;
}
/**
 *
 * @param count
 * @returns [columns, rows]
 */
export function gridSize(count) {
    const sqrt = Math.sqrt(count);
    let closestDivisor = 1;
    for (let i = Math.floor(sqrt); i > 1; i--) {
        if (count % i === 0) {
            closestDivisor = i;
            break;
        }
    }
    return [count / closestDivisor, closestDivisor];
}
export function ucfirst(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const pathRegexp = /^(\/)?(.+\/)*(.+)\.(.+)$/i;
export function getFilenameFromPath(path) {
    const result = pathRegexp.exec(path);
    if (!result)
        return null;
    return result[3];
}
export function array(length, mapfn) {
    const len = typeof length === "number" ? length : length[0] * length[1];
    return Array.from({ length: len }, mapfn);
}
export function rand(min = 0, max = 1, decimals = 6) {
    let v = Math.random() * (max - min) + min;
    return Math.round(v * 10 ** decimals) / 10 ** decimals;
}
export function texCoords([columns, rows]) {
    var texCoords = [];
    for (var i = 0; i < rows; i++) {
        for (var j = 0; j < columns; j++) {
            var s = (j / (columns - 1)) * 2 - 1;
            var t = (i / (rows - 1)) * 2 - 1;
            texCoords.push(s, t);
        }
    }
    return new Float32Array(texCoords);
}
export function imageToCanvas(image, dstWidth = image.width, dstHeight = image.height, imageOffsetX = 0, imageOffsetY = 0, srcWidth = image.width, srcHeight = image.height) {
    const canvas = document.createElement("canvas");
    canvas.width = dstWidth;
    canvas.height = dstHeight;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(image, imageOffsetX, imageOffsetY, srcWidth, srcHeight, 0, 0, dstWidth, dstHeight);
    return canvas;
}
export function toSource(obj) {
    function replacer(key, value) {
        if (typeof value === "function") {
            return value.toString();
        }
        return value;
    }
    return JSON.stringify(obj, replacer);
}
export function nameOrProps(props = {}) {
    return typeof props === "string" ? { name: props } : props;
}
